jQuery(function($) {
  $('body').scroll(function() {

    if ($('.steps').length) {
      let top_of_element = $('.steps').offset().top;
      let bottom_of_element = $('.steps').offset().top + $('.steps').outerHeight();
      let bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
      let top_of_screen = $(window).scrollTop();
      if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element)) {
        $('.ring').addClass('fill');
      }
      // else {
      //   $('.ring').removeClass('fill');
      // }
    }
  });
});
